// export const apiUrl = 'http://localhost:8000/api';
// export const domainUrl = 'http://localhost:8000';
export const apiUrl = 'https://primatus.corientbiz.com/api';
export const domainUrl = 'https://primatus.corientbiz.com';
